import api from '../helpers';

export default {
  /**
   * Fetch company hierarchy for registration (public endpoint)
   */
  getCompanies: {
    key: 'fetchRegistrationCompanies',
    query: () => {
      return api.get('/api/enterprise/companies', {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      // Transform array to object keyed by id for tree rendering
      return data.reduce((acc, company) => {
        return {
          ...acc,
          [company._id]: {
            id: company._id,
            companyName: company.name,
            hasChildren: company.hasChildren,
            parentCompanyId: company.parentCompanyId,
          },
        };
      }, {});
    },
  },

  /**
   * Register new account with company selection (public endpoint)
   */
  registerWithCompany: {
    key: 'registerAccountWithCompany',
    query: ({ firstName, lastName, email, password, companyId, role }) => {
      return api.post('/api/enterprise/register', {
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          firstName,
          lastName,
          email,
          password,
          companyId,
          role,
        },
      });
    },
  },
};
